import axiosV2 from './_defaults/v2/anonymous';

export async function getAccessibilities(params) {
    try {

        let realParams = {
            ...params
        }

        const response = await axiosV2.get(`/accessibilities`, { params: realParams });

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 404) return [];
        console.log(error.response);
        throw error;
    }
}

export async function getAccessibilitie({ slug, params }) {
    try {
        const response = await axiosV2.get(`/accessibilities/${slug}`, { params });

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 404) return [];
        console.log(error.response);
        throw error;
    }
}